"use client";

import Slider from "react-slick";
import { MutableRefObject } from "react";
import { TopProductsResponse } from "./best-selling-products";
import { ProductCardUI } from "../product-card/product-card-ui";

interface Props {
  data: TopProductsResponse[];
  sliderRef: MutableRefObject<Slider | null>;
}

export const BestSellingProductsSlider = ({ data, sliderRef }: Props) => {
  const settings = {
    arrows: false,
    infinite: data.length > 3,
    speed: 500,
    slidesToShow: 5,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          arrows: true,
        },
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          arrows: false,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
        },
      },
    ],
  };

  return (
    <Slider
      className="container mx-auto product-cards-equal-height"
      ref={sliderRef}
      {...settings}
    >
      {data.map((product) => (
        <div
          className="flex flex-col relative w-full px-1 h-full"
          key={product.id}
        >
          <ProductCardUI product={product} pageType="products" />
        </div>
      ))}
    </Slider>
  );
};
